/**
 * Dashboard - Events listing
 */

'use strict';

// Constructor
var FrontDashboardEventsIndex = function () {
    if (!($('body').hasClass('dashboard-events') || $('body').hasClass('dashboard-events-publish') || $('body').hasClass('dashboard-events-draft') || $('body').hasClass('dashboard-events-pending'))) {
        return;
    }

    $(document).ready((function () {
        this.updateStateSelect();
        this.stateSelectLoadPage();
        this.openModalDelete();
        this.delete();
        this.updateStatus();
        this.uiMatchHeight();
    }).bind(this));
};

FrontDashboardEventsIndex.prototype = {
    updateStateSelect: function () {
        var state = $('.listing').data('state');

        var select = $('.section-actions select.state-select')

        if (state.length > 0) {
            select.find('option[value="' + state + '"]').prop('selected', true);
            select.formSelect();
        }
    },

    stateSelectLoadPage: function () {
        $('.section-actions select.state-select').on('change', function () {
            var state = $(this).val();
            if (state.length > 0) {
                var url = $(this).find('[value=' + state + ']').data('url');
            } else {
                var url = $(this).find('[value=""]').data('url');
            }
            window.location = url;
        });
    },

    openModalDelete: function() {
        $('body').on('click', '.item .btn-delete', function() {
            var idValue = $(this).data('id');
            var modalElement = $('#modal-dashboard-event-delete');

            modalElement.find('.btn-confirm').attr('data-id', idValue);

            modalElement.find('.content-before').removeClass('hidden');
            modalElement.find('.content-after').addClass('hidden');

            modalElement.find('.btn-confirm').removeClass('disabled');
            modalElement.find('.content-before .modal-action').removeClass('disabled');

            modalElement.modal('open');
        });
    },

    delete: function () {
        var self = this;
        var modalElement = $('#modal-dashboard-event-delete');

        $('#modal-dashboard-event-delete .btn-confirm').on('click', function () {
            var idValue = $(this).attr('data-id');

            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            $('.preloader-wrapper', modalElement).fadeIn();

            $('.content-before .btn-confirm', modalElement).addClass('disabled');
            $('.content-before .modal-action', modalElement).addClass('disabled');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'dashboard.events.delete',
                    security: comedien.security,
                    idEvent: idValue,
                }
            }).done(function (response) {
                if (response.success) {
                    $('.preloader-wrapper', modalElement).fadeOut();
                    modalElement.find('.content-before').addClass('hidden');
                    modalElement.find('.content-after').removeClass('hidden');
                    $('.item .btn-delete[data-id=' + idValue + ']').parents('.item').fadeOut(500).remove();

                    self.uiMatchHeight();
                }

                $('.preloader-wrapper', modalElement).hide();

                self.lockAjaxForm = false;
                modalElement.find('.btn-confirm').attr('data-id', '');
                modalElement.modal('close');
            }).fail(function (jqXHR, textStatus) {
                $('.preloader-wrapper', modalElement).hide();
                self.lockAjaxForm = false;
                console.log("Request failed: " + textStatus);
                modalElement.modal('close');
            });
        });
    },

    updateStatus: function() {
        var self = this;

        $('.update-status').change(function() {
            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            if ($(this).is(":checked")) {
                // Enable the post
                var statusValue = 1;
            } else {
                // Disable the post
                var statusValue = 0;
            }

            var item = $(this).parents('.item');

            $('.preloader-wrapper', item).fadeIn();

            var idValue = $(this).parents('.inner').find('.edition .btn-delete').data('id');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'dashboard.events.update_status',
                    security: comedien.security,
                    idEvent: idValue,
                    status: statusValue
                }
            }).done(function (response) {
                if (response.success) {
                    $('.preloader-wrapper', item).fadeOut();

                    if (statusValue == 0) {
                        $('.item .btn-delete[data-id=' + idValue + ']').parents('.item').fadeOut();
                    }
                }

                self.lockAjaxForm = false;
                $('.preloader-wrapper', item).hide();
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
                $('.preloader-wrapper', item).hide();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
            });
        });
    },

    uiMatchHeight: function() {
        $('#dashboard-events .item').matchHeight();
        $('main#content > .col').matchHeight();
    },
};

module.exports = new FrontDashboardEventsIndex();
